import { useEffect } from 'react';
import { useAppDispatch } from '../../../store';
import { useHandleGoogleCodeMutation } from '../api/authApi';
import { setAuthResponse } from '../state/authSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const useHandleGoogleCallback = (code: string | null, error: string | null) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [handleGoogleCode, { isLoading }] = useHandleGoogleCodeMutation();

  const handleCode = async (code: string) => {
    try {
      const res = await handleGoogleCode({ code }).unwrap();
      dispatch(setAuthResponse(res));
      navigate('/books');
      toast('Logged in successfully', { type: 'success' });
    } catch (err) {
      toast('Something went wrong', { type: 'error' });
      navigate('/');
      return err;
    }
  };

  useEffect(() => {
    if (code) {
      handleCode(code);
    }
    if (error) {
      toast('Something went wrong', { type: 'error' });
      navigate('/');
    }
  }, [code, error]);

  return { isLoading };
};
